import createLucideIcon from '../createLucideIcon';

const Diamond = createLucideIcon('Diamond', [
  [
    'rect',
    {
      width: '15.56',
      height: '15.56',
      x: '12',
      y: '1',
      rx: '2.41',
      transform: 'rotate(45 12 1)',
      key: 'mruvuj',
    },
  ],
]);

export default Diamond;
